
import { Link } from 'react-router-dom';

export default function PolicyCta() {
  return (
    <section className="py-20 bg-[#F1F8E9]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://public.readdy.ai/ai/img_res/5b64670055aeb094f09063c6f48c6311.jpg"
              alt="Daliah Secret Collection"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#1B5E20]/90 via-[#2E7D32]/80 to-[#1B5E20]/70"></div>
          </div>
          <div className="relative z-10 py-16 px-12 text-center">
            <h2 className="text-3xl font-serif text-white mb-4">Still Have Questions?</h2>
            <p className="text-white/80 text-sm max-w-md mx-auto mb-8 leading-relaxed">
              Our customer care team is here to help. Reach out and we\u2019ll get back to you within 24 hours.
            </p>
            <div className="flex items-center justify-center gap-4">
              <a
                href="mailto:support@daliahsecret.com"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full bg-white text-[#2E7D32] font-medium text-sm hover:bg-[#E8F5E9] transition-colors cursor-pointer whitespace-nowrap"
              >
                <i className="ri-mail-line"></i>
                Email Us
              </a>
              <Link
                to="/products"
                className="inline-flex items-center gap-2 px-7 py-3 rounded-full border-2 border-white text-white font-medium text-sm hover:bg-white hover:text-[#2E7D32] transition-all cursor-pointer whitespace-nowrap"
              >
                Continue Shopping
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
